import { API_PATHS } from "../constants/api-paths";
import { IMFLInsert } from "../types/sso.types";
import { IResponse, encryptedRequest } from "../core/api.client";

export interface IMFLInsertRequest extends IMFLInsert {
  firstName: string;
  middleName: string;
  lastName: string;
  dob: string;
  mobileNo: string;
  pan: string;
  gender: string;
  appId: string;
}

export interface IMFLApiResponse {
  id: string;
}

export const mflInsertAPI = async (
  mflInsertRequestData: IMFLInsertRequest
): Promise<IResponse<IMFLApiResponse>> => {
  const response = await encryptedRequest<IMFLApiResponse, IMFLInsertRequest>({
    method: "POST",
    url: API_PATHS.mflInsert,
    data: mflInsertRequestData,
  });

  return response;
};
